export const deConsultingTypes = {
	consultingType: {
		0: {
			'titles': {
				default: 'Suchtberatung',
				short: 'Sucht',
				long: 'Suchtberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Suchtberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		1: {
			titles: {
				default: '[U25]',
				short: '[U25]',
				long: 'Beratung für suizidgefährdete junge Menschen [U25]',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown:
					'Beratung für suizidgefährdete junge Menschen [U25]'
			},
			anonymous: {
				text: 'Du bleibst anonym und erhältst kostenfreie Beratung und Hilfe',
				title: 'Anonym und kostenfrei'
			},
			requiredComponents: {
				age: {
					'0': 'unter 12',
					'1': '12',
					'2': '13',
					'3': '14',
					'4': '15',
					'5': '16',
					'6': '17',
					'7': '18',
					'8': '19',
					'9': '20',
					'10': '21',
					'11': '22',
					'12': '23',
					'13': '24',
					'14': '25',
					'15': 'über 25'
				}
			}
		},
		2: {
			'titles': {
				default: 'Schwangerschaftsberatung',
				short: 'Schwangerschaft',
				long: 'Schwangerschaftsberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Schwangerschaftsberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Du bleibst anonym und erhältst kostenfreie Beratung und Hilfe'
		},
		3: {
			'titles': {
				default: 'Eltern und Familien',
				short: 'Eltern Familie',
				long: 'Beratung für Eltern und Familien',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Eltern und Familien'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		4: {
			'titles': {
				default: 'Kurberatung',
				short: 'Kurberatung',
				long: 'Kurberatung für Mütter und Väter',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Kurberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		5: {
			'titles': {
				default: 'Schuldnerberatung',
				short: 'Schulden',
				long: 'Beratung zum Thema Schulden',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Schuldnerberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		6: {
			'titles': {
				default: 'Sozialberatung',
				short: 'ASB',
				long: 'Allgemeine Sozialberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Sozialberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		7: {
			'titles': {
				default: 'Leben im Alter',
				short: 'Alter',
				long: 'Leben im Alter',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Leben im Alter'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		8: {
			'titles': {
				default: 'Beeinträchtigung',
				short: 'Beeinträchtigung',
				long: 'Leben mit Behinderung und psychischer Erkrankung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Beeinträchtigung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		9: {
			'titles': {
				default: 'Go on – Start up!',
				short: 'Go on – Start up!',
				long: 'Go on – Start up!',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Go on – Start up!'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Du bleibst anonym und erhältst kostenfreie Beratung und Hilfe'
		},
		10: {
			'titles': {
				default: 'Rechtliche Betreuung und Vorsorge',
				short: '(rechtl.) Betreuung',
				long: 'Rechtliche Betreuung und Vorsorge',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Rechtliche Betreuung und Vorsorge'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		11: {
			'titles': {
				default: 'Straffälligenhilfe',
				short: 'Straffälligenhilfe',
				long: 'Beratung für Angehörige von Straffälligen',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Straffälligenhilfe'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		12: {
			'titles': {
				default: 'HIV / AIDS',
				short: 'HIV',
				long: 'HIV/AIDS-Beratung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'HIV / AIDS'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		13: {
			'titles': {
				default: 'Kinder-Reha',
				short: 'Kinder-Reha',
				long: 'Kinder- und Jugend-Rehabilitation',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Kinder-Reha'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		14: {
			'titles': {
				default: 'Kinder Jugendliche',
				short: 'Kinder Jugendliche',
				long: 'Beratung für Kinder und Jugendliche',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Kinder Jugendliche'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Du bleibst anonym und erhältst kostenfreie Beratung und Hilfe'
		},
		15: {
			'titles': {
				default: 'Sucht',
				short: 'Sucht',
				long: 'Sucht-Selbsthilfe – Kreuzbund-Chat',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Sucht-Selbsthilfe - Kreuzbund'
			},
			'groupChatRules': {
				'0': 'In der Sucht-Selbsthilfe duzen wir uns, sowohl in den Gruppen vor Ort als auch hier im Chat. Wer damit Probleme hat, teile das im Chat mit – wir stellen uns gerne darauf ein!',
				'1': 'Menschen sind verschieden, ihre Meinungen sind es auch. Aufeinander zu achten sowie wertschätzende Chat-Beiträge gewährleisten ein helfendes Miteinander.',
				'2': 'Moderator_innen haben die Aufgabe, dafür zu sorgen, dass sich die Chat-Teilnehmenden austauschen können. Sie bieten gegebenenfalls auch Sucht-Themen zur Diskussion an. Ihren Aufforderungen ist zu folgen, beispielsweise dann, wenn Chat-Regeln nicht eingehalten werden.'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		16: {
			'titles': {
				default: 'Migrationsberatung',
				short: 'Migrationsberatung',
				long: 'Migrationsberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Migrationsberatung'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		17: {
			'titles': {
				default: 'Auswanderung',
				short: 'Auswanderung',
				long: 'Aus-/Rück- & Weiterwanderung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Auswanderung'
			},
			'anonymous.title': 'Anonym',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten Beratung und Hilfe'
		},
		18: {
			'titles': {
				default: 'Hospiz-Palliativ-Trauer',
				short: 'Hospiz-Palliativ',
				long: 'Hospiz-, Palliativ- und Trauerberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Hospiz-Palliativ-Trauer'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		19: {
			'titles': {
				default: 'Regionale Angebote',
				short: 'Regionale Angebote',
				long: 'Regionale Angebote',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Regionale Angebote'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		20: {
			'titles': {
				default: 'Jungen und Männer',
				short: 'Jungen und Männer',
				long: 'Jungen- und Männerberatung',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Jungen und Männer'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe'
		},
		21: {
			'titles': {
				default: 'Selbsthilfe Vechta',
				short: 'Selbsthilfe',
				long: 'Kontakt- und Beratungsstelle Selbsthilfe',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: 'Selbsthilfe Vechta'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Sie bleiben anonym und erhalten kostenfreie Beratung und Hilfe',
			'groupChatRules': {
				'0': 'In der Selbsthilfe duzen wir uns, sowohl in den Gruppen vor Ort als auch hier im Chat. Wer damit Probleme hat, teile das im Chat mit – wir stellen uns gerne darauf ein!',
				'1': 'Menschen sind verschieden, ihre Meinungen sind es auch. Aufeinander zu achten sowie wertschätzende Chat-Beiträge gewährleisten ein helfendes Miteinander.',
				'2': 'Moderator_innen haben die Aufgabe, dafür zu sorgen, dass sich die Chat-User_innen austauschen können. Ihren Aufforderungen ist zu folgen, beispielsweise dann, wenn Chat-Regeln nicht eingehalten werden.'
			}
		},
		22: {
			'titles': {
				default: '#gemeinsamstatteinsam',
				short: '#gse',
				long: '#gemeinsamstatteinsam – Onlineberatung für junge Menschen in besonderen Zeiten',
				welcome: 'Willkommen bei der Online-Beratung',
				registrationDropdown: '#gemeinsamstatteinsam'
			},
			'anonymous.title': 'Anonym und kostenfrei',
			'welcomeScreen.anonymous.text':
				'Du bleibst anonym und erhältst kostenfreie Beratung und Hilfe'
		}
	}
};
